import n, { css as e } from "styled-components";
import { POSITION as d } from "../../../constants/position.es.js";
import { Typography as b } from "../../Typography/Typography.es.js";
import { Icon as m } from "../../DataDisplay/Icon/Icon.es.js";
const a = "1.8rem", r = n.label.withConfig({
  displayName: "InputCheckmark",
  componentId: "sc-132swk3-0"
})(["align-items:center;background-color:var(--color-components-input-bg-default);border:2px solid var(--color-components-input-border-strong);border-radius:var(--size-components-input-border-radius-sm);display:flex;height:", ";justify-content:center;min-width:", ";width:", ";"], a, a, a), s = n(b).withConfig({
  displayName: "InputLabel",
  componentId: "sc-132swk3-1"
})(["-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;display:inline-block;font-size:1.4rem;position:relative;user-select:none;"]), o = n.input.withConfig({
  displayName: "InputElement",
  componentId: "sc-132swk3-2"
})(["display:none;&:disabled{cursor:not-allowed;opacity:0.4;}"]), g = {
  [d.left]: {
    order: -1
  },
  [d.top]: {
    order: -1,
    flexDirection: "column"
  },
  [d.bottom]: {
    flexDirection: "column"
  },
  [d.right]: {}
}, y = n.div.withConfig({
  displayName: "InputBody",
  componentId: "sc-132swk3-3"
})(["align-items:", ";display:flex;gap:var(--size-gap-4);", ""], ({
  alignItems: c = "center"
}) => c, ({
  labelPosition: c
}) => c && g[c]), w = n.div.withConfig({
  displayName: "Input",
  componentId: "sc-132swk3-4"
})(["display:flex;flex-direction:column;gap:var(--size-gap-4);width:fit-content;&:hover{", "{background-color:var(--color-components-input-bg-hover-weakest);border:2px solid var(--color-components-input-border-strong);}", "}", ""], r, ({
  error: c,
  success: t,
  type: i
}) => !c && !t && i === "checkbox" && e(["", ":checked ~ ", ",", ":indeterminate ~ ", "{background-color:var(--color-accent-primary-stronger);border:2px solid var(--color-accent-primary-stronger);}"], o, r, o, r), ({
  disabled: c,
  error: t,
  success: i,
  type: l
}) => {
  var p, u;
  return e(["", "{", " ", "{display:none;width:calc(", " / 1.5);}}", ":checked ~ ", ",", ":indeterminate ~ ", "{", " ", " ", "{display:block;}}", " ", " ", " ", ""], r, l === "radio" && e(["border-radius:var(--size-border-radius-circle);"]), (p = m.S) == null ? void 0 : p.Icon, a, o, r, o, r, l === "checkbox" && e(["background-color:var(--color-accent-primary-default);border:2px solid var(--color-accent-primary-default);color:var(--color-components-input-bg-default);"]), t && e(["background-color:var(--color-error-default);border:2px solid var(--color-error-default);"]), (u = m.S) == null ? void 0 : u.Icon, l === "radio" && e(["", ":checked ~ ", "{background-color:transparent;border:2px solid var(--color-accent-primary-default);&:after{background-color:var(--color-accent-primary-default);border-radius:var(--size-border-radius-circle);content:'';height:calc(", " - 0.8rem);width:calc(", " - 0.8rem);}}"], o, r, a, a), t && e(["", ",", ":indeterminate ~ ", "{background-color:var(--color-error-weakest);border-color:var(--color-error-default);}", ":checked ~ ", ":after{background-color:var(--color-error-default);}", "{color:var(--color-error-default);}&:hover{", "{background-color:var(--color-error-weakest);border:2px solid var(--color-error-strong);}}"], r, o, r, o, r, s, r), i && e(["", ",", ":indeterminate ~ ", "{background-color:var(--color-success-weakest);border-color:var(--color-accent-primary-default);}", ":checked ~ ", ":after{background-color:var(--color-accent-primary-default);}", "{color:var(--color-accent-primary-default);}&:hover{", "{background-color:var(--color-success-weakest);border-color:var(--color-success-strong);}}"], r, o, r, o, r, s, r), c && e(["cursor:not-allowed;opacity:0.4;", ",", ",", "{cursor:not-allowed;}", ":checked ~ ", ",", ":indeterminate ~ ", "{", "}"], s, r, o, o, r, o, r, l === "checkbox" && e(["background:var(--color-components-input-bg-strong);border:2px solid var(--color-transparent);"])));
});
export {
  w as Input,
  y as InputBody,
  r as InputCheckmark,
  o as InputElement,
  s as InputLabel
};
//# sourceMappingURL=style.es.js.map
